
@if (intercomBootFailed()) {
  <div id="warning">
    <app-toast
      toastStyle="warning"
      icon="warning"
      text="Support chat failed to load. Please refresh the page or contact support if the issue persists."
    >
    </app-toast>
  </div>
}
@if (displayWarning) {
  <div id="warning">
    <app-toast
      toastStyle="critical"
      icon="warning"
      text="Warning: You are currently viewing an organisation you are not a member
      of"
    >
    </app-toast>
  </div>
}
<div id="app">
  <!-- HEADER -->
  @if (currentUser && showNavbar()) {
    <app-navbar></app-navbar>
  }
  <div class="page--container">
    <!-- ROUTES RENDERED HERE -->
    <router-outlet></router-outlet>
  </div>
</div>
